import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import './App.css';
import logo from './logo.jpg';
import GamesPage from './GamesPage';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gradient-to-br from-gray-900 via-purple-900 to-violet-900 flex flex-col">
        <Header />
        <main className="flex-grow container mx-auto px-4 py-8">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/games" element={<GamesPage />} />
            <Route path="/video" element={<VideoPage />} />
            <Route path="/music" element={<MusicPage />} />
            <Route path="/news" element={<NewsPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  
  return (
    <header className="bg-gradient-to-r from-purple-800 via-violet-800 to-purple-900 text-white shadow-2xl backdrop-blur-lg bg-opacity-90 sticky top-0 z-50">
      <nav className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <div className="w-8 h-8 sm:w-10 sm:h-10 bg-gradient-to-br from-purple-400 to-pink-400 rounded-full flex items-center justify-center shadow-lg">
              <img src={logo} alt="logo" className="w-6 h-6 sm:w-8 sm:h-8 rounded-full" />
            </div>
            <span className="text-lg sm:text-xl font-bold bg-gradient-to-r from-purple-200 to-pink-200 bg-clip-text text-transparent">oldmelnik</span>
          </div>
          
          {/* Desktop Navigation */}
          <div className="hidden md:flex space-x-6 lg:space-x-8">
            <NavLink to="/">Главная</NavLink>
            <NavLink to="/games">Игры</NavLink>
            <NavLink to="/video">Видео</NavLink>
            <NavLink to="/music">Музыка</NavLink>
            <NavLink to="/news">Новости</NavLink>
          </div>
          
          {/* User Info - Desktop */}
          <div className="hidden sm:flex items-center space-x-3 lg:space-x-4">
            <span className="text-purple-200 text-sm lg:text-base">Yuri Smirnov</span>
            <div className="w-6 h-6 lg:w-8 lg:h-8 bg-gradient-to-br from-blue-400 to-purple-400 rounded-full flex items-center justify-center">
              <span className="text-white text-xs font-bold">ЮС</span>
            </div>
          </div>
          
          {/* Mobile Menu Button */}
          <button 
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 rounded-lg bg-purple-700 bg-opacity-50 hover:bg-opacity-70 transition-all duration-300"
          >
            <div className="w-6 h-5 flex flex-col justify-center space-y-1">
              <span className={`block h-0.5 w-full bg-white transition-all duration-300 ${isMenuOpen ? 'rotate-45 translate-y-1.5' : ''}`}></span>
              <span className={`block h-0.5 w-full bg-white transition-all duration-300 ${isMenuOpen ? 'opacity-0' : ''}`}></span>
              <span className={`block h-0.5 w-full bg-white transition-all duration-300 ${isMenuOpen ? '-rotate-45 -translate-y-1.5' : ''}`}></span>
            </div>
          </button>
        </div>
        
        {/* Mobile Menu */}
        <div className={`md:hidden transition-all duration-300 ease-in-out overflow-hidden ${
          isMenuOpen ? 'max-h-64 opacity-100' : 'max-h-0 opacity-0'
        }`}>
          <div className="py-4 space-y-3 border-t border-purple-600 border-opacity-30 mt-4">
            <MobileNavLink to="/" onClick={() => setIsMenuOpen(false)}>Главная</MobileNavLink>
            <MobileNavLink to="/games" onClick={() => setIsMenuOpen(false)}>Игры</MobileNavLink>
            <MobileNavLink to="/video" onClick={() => setIsMenuOpen(false)}>Видео</MobileNavLink>
            <MobileNavLink to="/music" onClick={() => setIsMenuOpen(false)}>Музыка</MobileNavLink>
            <MobileNavLink to="/news" onClick={() => setIsMenuOpen(false)}>Новости</MobileNavLink>
            
            {/* Mobile User Info */}
            <div className="flex items-center justify-between pt-4 border-t border-purple-600 border-opacity-30">
              <div className="flex items-center space-x-2">
                <span className="text-purple-200 text-sm">Yuri Smirnov</span>
                <div className="w-6 h-6 bg-gradient-to-br from-blue-400 to-purple-400 rounded-full flex items-center justify-center">
                  <span className="text-white text-xs font-bold">ЮС</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
};

const NavLink = ({ to, children }) => (
  <Link 
    to={to} 
    className="relative text-purple-200 hover:text-white transition-all duration-300 transform hover:scale-105 group text-sm lg:text-base"
  >
    {children}
    <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-purple-400 to-pink-400 group-hover:w-full transition-all duration-300"></span>
  </Link>
);

const MobileNavLink = ({ to, children, onClick }) => (
  <Link 
    to={to} 
    onClick={onClick}
    className="block w-full text-left px-4 py-3 text-purple-200 hover:text-white hover:bg-purple-700 hover:bg-opacity-30 rounded-lg transition-all duration-300 text-base"
  >
    {children}
  </Link>
);

const PageLayout = ({ title, children }) => (
  <div className="bg-white bg-opacity-10 backdrop-blur-md rounded-2xl shadow-2xl p-4 sm:p-6 lg:p-8 border border-purple-300 border-opacity-20">
    <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold mb-6 sm:mb-8 text-transparent bg-gradient-to-r from-purple-200 to-pink-200 bg-clip-text">{title}</h1>
    {children}
  </div>
);

// Страницы
const HomePage = () => (
  <PageLayout title="Welcome">
    <div className="space-y-6 sm:space-y-8">
      <div className="text-center space-y-4">
        <div className="w-24 h-24 sm:w-32 sm:h-32 mx-auto bg-gradient-to-br from-purple-400 to-pink-400 rounded-full flex items-center justify-center shadow-2xl mb-4 sm:mb-6">
          <img src={logo} alt="logo" className="w-20 h-20 sm:w-24 sm:h-24 rounded-full" />
        </div>
        <h2 className="text-2xl sm:text-3xl font-bold text-white">oldmelnik</h2>
        <p className="text-lg sm:text-xl text-purple-200 px-4">Создатель игр, музыки и видео контента</p>
      </div>
      
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 mt-8 sm:mt-12">
        <NavLink to="/games">
        <div className="bg-gradient-to-br from-purple-600 to-purple-800 p-4 sm:p-6 rounded-xl shadow-xl transform hover:scale-105 transition-all duration-300">
          <h3 className="text-lg sm:text-xl font-bold text-white mb-2">🎮 Игры</h3>
          <p className="text-purple-200 text-sm sm:text-base">Уникальные игры и проекты</p>
        </div>
        </NavLink>
        <NavLink to="/music">
        <div className="bg-gradient-to-br from-pink-600 to-pink-800 p-4 sm:p-6 rounded-xl shadow-xl transform hover:scale-105 transition-all duration-300">
          <h3 className="text-lg sm:text-xl font-bold text-white mb-2">🎵 Музыка</h3>
          <p className="text-pink-200 text-sm sm:text-base">Оригинальные треки</p>
        </div>
        </NavLink>
        <NavLink to="/video">
        <div className="bg-gradient-to-br from-violet-600 to-violet-800 p-4 sm:p-6 rounded-xl shadow-xl transform hover:scale-105 transition-all duration-300">
          <h3 className="text-lg sm:text-xl font-bold text-white mb-2">🎬 Видео</h3>
          <p className="text-violet-200 text-white sm:text-base">Смешной видео контент</p>
        </div>
        </NavLink>
      </div>
      
      <div className="flex flex-col sm:flex-row justify-center items-center space-y-4 sm:space-y-0 sm:space-x-6 mt-8 sm:mt-12 px-4">
        <a href="https://oldmelnik.ru" target="_blank" rel="noopener noreferrer" 
           className="bg-gradient-to-r from-purple-500 to-pink-500 text-white px-6 py-3 rounded-full shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300 w-full sm:w-auto text-center">
          🌐 Мой сайт
        </a>
        <a href="https://www.youtube.com/@oldmelnik99" target="_blank" rel="noopener noreferrer" 
           className="bg-gradient-to-r from-red-500 to-red-700 text-white px-6 py-3 rounded-full shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300 w-full sm:w-auto text-center">
          📺 YouTube
        </a>
        <a href="https://github.com/Oldmelnik" target="_blank" rel="noopener noreferrer" 
           className="bg-gradient-to-r from-red-500 to-red-700 text-white px-6 py-3 rounded-full shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300 w-full sm:w-auto text-center">
          Github
        </a>
        <a href="https://steamcommunity.com/id/Ooldmelnik99" target="_blank" rel="noopener noreferrer" 
           className="bg-gradient-to-r from-red-500 to-red-700 text-white px-6 py-3 rounded-full shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300 w-full sm:w-auto text-center">
          Steam
        </a>
        <a href="https://vk.com/yurs777" target="_blank" rel="noopener noreferrer" 
           className="bg-gradient-to-r from-red-500 to-red-700 text-white px-6 py-3 rounded-full shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300 w-full sm:w-auto text-center">
          VK
        </a>
      </div>
    </div>
  </PageLayout>
);


const VideoPage = () => (
  <PageLayout title="Видео контент">
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
      {['GTA 9 Gameplay', 'CS MIN Tournament', 'qupe Speedrun', 'homefrigths Horror'].map((title, index) => (
        <div key={index} className="bg-gradient-to-br from-purple-700 to-purple-900 p-4 sm:p-6 rounded-xl shadow-xl hover:shadow-2xl transform hover:scale-105 transition-all duration-300">
          <div className="w-full h-32 sm:h-40 bg-gradient-to-br from-purple-600 to-pink-600 rounded-lg mb-4 flex items-center justify-center">
            <span className="text-3xl sm:text-4xl">🎬</span>
          </div>
          <h3 className="text-lg sm:text-xl font-bold text-white mb-2">{title}</h3>
          <p className="text-purple-200 text-sm sm:text-base">Видео контент</p>
        </div>
      ))}
    </div>
  </PageLayout>
);

const MusicPage = () => (
  <PageLayout title="Музыкальные произведения">
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
      {['dndoomwalker', 'doot', 'dnbus', 'uac'].map((title, index) => (
        <div key={index} className="bg-gradient-to-br from-pink-700 to-pink-900 p-4 sm:p-6 rounded-xl shadow-xl hover:shadow-2xl transform hover:scale-105 transition-all duration-300">
          <div className="flex items-center space-x-3 sm:space-x-4 mb-4">
            <div className="w-12 h-12 sm:w-16 sm:h-16 bg-gradient-to-br from-pink-500 to-purple-500 rounded-full flex items-center justify-center">
              <span className="text-xl sm:text-2xl">🎵</span>
            </div>
            <div className="flex-1">
              <h3 className="text-lg sm:text-xl font-bold text-white">{title}</h3>
              <p className="text-pink-200 text-xs sm:text-sm">Оригинальная композиция</p>
            </div>
          </div>
          <div className="w-full h-2 bg-pink-800 rounded-full mb-2">
            <div className="w-3/4 h-2 bg-gradient-to-r from-pink-400 to-purple-400 rounded-full"></div>
          </div>
        </div>
      ))}
    </div>
    <a href="https://disk.yandex.ru/d/1FnKkz8RaOxwHw" target="_blank" rel="noopener noreferrer"
    className="bg-gradient-to-br from-red-500 to-pink-900 p-4 sm:p-6 rounded-xl 
    shadow-xl hover:shadow-2xl transform hover:scale-105 transition-all duration-300
    text-white"
    style={{
      display: 'flex',
      justifyContent: 'center',
      margin: '25px'
    }}
    >Прослушать на Яндекс Диске</a>
  </PageLayout>
);

const NewsPage = () => (
  <PageLayout title="Новости и обновления">
    <div className="space-y-4 sm:space-y-6">
      {[
        { title: 'Новая игра в разработке', date: '2025-01-15', content: 'Работаю над новым увлекательным проектом...' },
        { title: 'Выпущен новый трек', date: '2024-01-10', content: 'Доступна новая музыкальная композиция...' },
        { title: 'Стрим на YouTube', date: '2024-01-05', content: 'Запланирован прямой эфир...' }
      ].map((news, index) => (
        <div key={index} className="bg-gradient-to-br from-violet-500 to-violet-300 p-4 sm:p-6 rounded-xl shadow-xl hover:shadow-2xl
         transform hover:scale-105 transition-all duration-300"
        >
          <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start space-y-2 sm:space-y-0 mb-3">
            <h3 className="text-lg sm:text-xl font-bold text-white">{news.title}</h3>
            <span className="text-red-100 text-xs sm:text-sm">{news.date}</span>
          </div>
          <p className="text-white text-sm sm:text-base leading-relaxed">{news.content}</p>
        </div>
      ))}
    </div>
  </PageLayout>
);

const Footer = () => (
  <footer className="bg-gradient-to-r from-purple-900 via-violet-900 to-purple-900 text-white py-6 sm:py-8 mt-12 sm:mt-16">
    <div className="container mx-auto px-4">
      <div className="flex flex-col space-y-6">
        
        {/* Links */}
        <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center space-y-4 sm:space-y-0">
          <div className="flex flex-col sm:flex-row space-y-3 sm:space-y-0 sm:space-x-6">
            <a rel="noopener noreferrer" 
               className="text-purple-200 hover:text-white transition-colors duration-300 text-sm sm:text-base">
              🌐  yuriuri777@gmail.com
            </a>
          </div>
          
          <div className="text-purple-300 text-xs sm:text-sm">
            © 2026 oldmelnik. Все права защищены.
          </div>
        </div>
      </div>
    </div>
  </footer>
);
export default App;
